import database from "./firebase";

export const contentTable = "content";
const contentRef = database.ref(contentTable);

export const productsTable = "productCategories";

const _categories = [
  {
    id: "1",
    name: "Maca sấy nứt",
    description: `Quy cách đóng gói: 500 gram và 250gram / sản phẩm
Size nhỏ : đường kính hạt <= 2.2 cm
Size trung : 2.3 cm >= đường kính hạt <= 2.5 cm
Size đại : đường kính hạt >= 2.6 cm`,
    background: "maca_2.jpg",
  },
  {
    id: "2",
    name: "Nhân maca sấy nứt",
    description: `Quy cách đóng gói: 500 gram và 250gram / sản phẩm`,
    background: "maca_13.jpg",
  },
  {
    id: "3",
    name: "Nhân maca làm sữa hạt",
    description: `Gọi là nhân khô sữa nhưng hạt mềm ngọt béo như nhân hạt tươi. Sản phẩm được hong mát để không bị lên men khi vận chuyển xa.
         Nhân Macca sấy sữa được dùng để làm sữa hạt, muối Macca, xay với các loại hạt khác thành bột ngũ cốc`,
    background: "maca_10.jpg",
  },
  {
    id: "4",
    name: "Dầu maca nguyên chất",
    description: `Dầu macca ép lạnh được dùng để mát xa da, dưỡng môi, tóc, và móng tay. Có thể dùng cho bé ăn dặm, trộn salad, ướp các món nướng.`,
    background: "maca_19.jpg",
  },
];

const _products = [
  {
    id: "1",
    order: 1,
    category: "1",
    name: "Maca sấy nứt\nBịch 500 gram",
    picture: "bich_hut_chan_khong.jpg",
    items: [
      // sub-product
      { id: "1", size: "Size đại", price: 210 },
      { id: "2", size: "Size trung", price: 175 },
      { id: "3", size: "Size nhỏ", price: 150 },
    ],
  },
  {
    id: "2",
    order: 2,
    category: "1",
    name: "Maca sấy nứt\nHộp giấy 500 gram",
    picture: "hop_giay.jpg",
    items: [
      { id: "1", size: "Size đại", price: 220 },
      { id: "2", size: "Size trung", price: 185 },
      { id: "3", size: "Size nhỏ", price: 160 },
    ],
  },
  {
    id: "3",
    order: 2,
    category: "1",
    name: "Maca sấy nứt\nBịch 250 gram",
    picture: "hop_giay.jpg",
    items: [
      { id: "1", size: "Size nhỏ", price: 82 },
      { id: "2", size: "Size ", price: 95 },
      { id: "3", size: "Size ", price: 110 },
    ],
  },
  {
    id: "4",
    order: 1,
    category: "2",
    name: "Nhân sấy size trung",
    picture: "maca_9.jpg",
    items: [
      { id: "1", size: "250gr", price: 250 },
      { id: "1", size: "500gr", price: 500 },
      { id: "1", size: "Hộp giấy 500gr", price: 510 },
    ],
  },
  {
    id: "5",
    order: 1,
    category: "2",
    name: "Nhân sấy size đại",
    picture: "maca_14.jpg",
    items: [
      { id: "1", size: "250gr", price: 275 },
      { id: "1", size: "500gr", price: 550 },
      { id: "1", size: "Hộp giấy 500gr", price: 560 },
    ],
  },
  {
    id: "6",
    order: 1,
    category: "3",
    name: "Nhân macca khô sữa",
    picture: "nhan_kho_sua.jpg",
    items: [{ id: "1", size: "250gr", price: 130 }],
  },
  {
    id: "7",
    order: 1,
    category: "3",
    name: "Nhân Macca sấy sữa",
    picture: "nhan_say_sua.jpg",
    items: [{ id: "1", size: "250gr", price: 143 }],
  },
  {
    id: "8",
    order: 1,
    category: "4",
    name: "Dầu maca 30ml",
    picture: "dau_300.jpg",
    items: [{ id: "1", size: "Chai 30ml", price: 120 }],
  },
  {
    id: "9",
    order: 2,
    category: "4",
    name: "Dầu maca 100ml",
    picture: "dau_100.jpg",
    items: [{ id: "1", size: "Chai 100ml", price: 320 }],
  },
];

export const introductionTable = "introduction";
export const aboutDetailsTable = "aboutDetails";
const _introduction = {
  text: [
    {
      id: 1,
      line: `Đắk Lắk vốn nổi tiếng về các loại nông sản có giá trị dinh dưỡng cao như cà phê, bơ, sầu riêng và
         trong những năm gần đây, vùng đất này lại được nhắc đến nhờ nữ hoàng quả khô- hạt macca. Macca Vạn Phúc
          tự hào là một trong những người tiên phong trong việc trồng giống cây này ở Đắk Lắk theo hướng hữu cơ,
           thân thiện với môi trường.`,
    },
    {
      id: 2,
      line: `Macca Vạn Phúc chúng tôi định hướng xây dựng nền nông nghiệp xanh - sạch - an toàn, vì sức khỏe của
         người lao động và người tiêu dùng.`,
    },
  ],
  signature: "Macca Vạn Phúc - Trao trọn cảm xúc yêu thương!",
};

const _aboutDetails = [
  {
    id: 1,
    text: "Vườn nguyên liệu Macca Vạn Phúc nằm trên đồi Pháo, Eahmlay, Mardrak Đắk Lắk nơi có khí hậu trong lành và nguồn nước giếng sạch dùng cho việc tưới tiêu..",
    image: "daklak.png",
  },
  {
    id: 2,
    text: "Bắt đầu với các giống chính là QN1, 816, COC, DADOWN, 246, 800, sau đó, vườn tiến hành cải tạo một số giống để phù hợp với khí hậu, thổ nhưỡng nhằm thu được hạt có chất lượng tốt nhất.",
    image: "maca_seedlings.jpg",
  },
  {
    id: 3,
    text: "Từ khi cây còn nhỏ vườn đã áp dụng hướng chăm sóc thân thiện với môi trường như dùng phân vi sinh, và các chế phẩm hữu cơ như bánh dầu, đạm cá, đạm tôm, rong biền, xác thực vật.",
    image: "maca_leaves.jpg",
  },
  {
    id: 4,
    text: "Mùa hoa Macca bắt đầu nở từ tháng 12, nở rộ vào tháng 1 và tháng 2 hàng năm. Nếu bạn muốn ghé thăm vườn nguyên liệu Macca Vạn Phúc thì thời điểm này là đẹp nhất trong năm.",
    image: "maca_flowers_2.jpg",
  },
  {
    id: 5,
    text: "Chúng tôi tiến hành thu hoạch khi trái đã đạt độ già tiêu chuẩn và bắt đầu khâu sấy ngay sau khi thu hoạch nhằm đảm bảo giá trị dinh dưỡng ở mức cao nhất và giữ được vị tươi, bùi, ngọt của hạt cũng như sẽ không có hạt bị hôi dầu.",
    image: "maca_nuts_half_open.jpg",
  },
  {
    id: 6,
    text: "Hạt Macca của Vạn Phúc được sấy theo kỹ thuật riêng bạn sẽ cảm nhận ngay được mùi thơm khi mở bao sản phẩm. Màu vàng đặc trưng, hạt giòn tan, độ ngọt, vị béo bùi đậm đà khác biệt sẽ làm hài lòng người thưởng thức.",
    image: "maca_18.jpg",
  },
];

export const nutritionFactsTable = "nutritionFacts";

const _nutritrionFacts = {
  text: [
    {
      id: 1,
      line: `Hạt macca chứa nhiều chất béo có lợi cho sức khỏe, vitamin và các loại khoáng chất.
         Chất béo không bão hòa đơn trong hạt macca giúp là giảm cholesterol tổng thể và cholesterol có hại (LDL).
          Ngoài ra, vì chứa ít tinh bột và đường nhưng lại có hàm lượng chất xơ đáng kể nên việc sử dụng hạt macca
        trong chế độ ăn uống hàng ngày không làm tăng lượng đường trong máu, điều này rất có lợi cho những ai
         đang phải điều trị bệnh tiểu đường. Giống như các loại hạt khác, hạt macca là một nguồn chứa nhiều chất chống
          oxy hóa giúp ngăn ngừa các bệnh như tiểu đường, Alzheimer's, ung thư và bệnh tim mạch.`,
    },
    {
      id: 2,
      line: `Mặc dù giàu năng lượng, hạt macca có thể giúp bạn giảm cân. Điều này được giải thích một phần do hàm lượng
         chất đạm và chất xơ, giúp làm giảm cơn đói và tăng cảm giác no. Chất xơ hòa tan trong hạt macca hoạt động
         như một “prebiotic", nghĩa là nó giúp nuôi các vi khuẩn có lợi cho đường tiêu và do đó tác động tích cực lên
         sức khỏe tiêu hóa của bạn. Bổ sung hạt macca vào chế độ ăn của bạn sẽ tăng cường sức khỏe trong dài hạn. Nên chú ý
         sử dụng vừa đủ lượng hạt mỗi ngày, lượng khuyên dùng khoảng 30 gram hay khoảng 15 hạt mỗi ngày.`,
    },
  ],
  background: "maca_14.jpg",
};

export const macaDishesTable = "macaDishes";
const _macaDishes = {
  text: [
    {
      id: 1,
      line: `Hạt macca rất dễ kết hợp với các loại thực phẩm khác. Điều này không những làm tăng hương vị của món ăn mà
         còn khiến việc thưởng thức macca thú vị hơn. Thực sự khó lòng kể hết bao nhiêu món ăn có thể kết hợp cùng macca.
         Chúng tôi chỉ xin đưa ra một vài gợi ý nho nhỏ sau và chắc hẳn bạn sẽ muốn kéo dài danh sách này nếu bạn thử một lần
         vào bếp với macca Vạn Phúc đấy!`,
    },
    {
      id: 2,
      line: `Ly sinh tố hay ly kem mát lạnh của bạn sẽ ngon hơn rất nhiều nếu bạn xay cùng hoặc rắc lên vài hạt macca giã nhỏ vừa phải.
        Đối với những ai yêu thích làm bánh, không ai có thể phủ nhận một điều rằng những chiếc bánh cookies hay brownies của bạn sẽ béo
        ngậy hơn rất nhiều khi sử dụng hạt macca. Món xôi thường hằng ngày cũng khác biệt hơn hẳn với chút macca rắc lên hoặc nấu cùng
        Macca khô sữa xay nhuyễn.`,
    },
    {
      id: 3,
      line: `Ngoài ra, nhân macca và dầu macca là cặp đôi hoàn hảo cho những đĩa salad, món cháo dinh dưỡng của con bạn hay món súp yêu
        thích mỗi sáng của bạn. Không hề có một giới hạn nào cho macca trong gian bếp của bạn. Hãy thêm một ít hạt vào đĩa pasta hay
        tô cơm chay của bạn hay bất cứ món nào bạn có thể nghĩ ra, chúng tôi tin là bạn sẽ không thât vọng đâu!`,
    },
  ],
  dishImages: [
    {
      id: 1,
      image: "maca_salad.jpg",
    },
    {
      id: 2,
      image: "maca_cake.jpg",
    },
    {
      id: 3,
      image: "maca_pumpkin_soup.png",
    },
    {
      id: 4,
      image: "maca_cookies.jpg",
    },
    {
      id: 5,
      image: "maca_tofu_2.jpg",
    },
    {
      id: 6,
      image: "maca_yoghurt_2.jpg",
    },
    {
      id: 7,
      image: "maca_pasta.jpg",
    },
  ],
};

export const companyInfoTable = "companyInfo";

const _companyInfo = {
  offices: [
    {
      address: "112/38 Tây Hòa, Phước Long A, Q.9, TP.Hồ Chí Minh",
      phone: "0971 864 805",
      email: "macavanphuc@gmail.com",
    },
  ],
  factories: [
    {
      address:
        "55B Lê Hồng Phong, Tổ Dân Phố 8, Thị Trấn Phước An, Huyện Krông Pắk, Tỉnh Đắk Lắk",
      phone: "0948 659 293 - 0983 841 115",
      email: "macavanphuc@gmail.com",
    },
  ],
};

export const agenciesTable = "agencies";
const _agencies = [
  {
    id: 1,
    name: "302/11 Đường số 8, Phường 11, Quận Gò Vấp",
    phone: "0914 225 512",
  },
  {
    id: 2,
    name: "Số 4 đường 12, Phường Hiệp Bình Chánh, Quận Thủ Đức",
    phone: "0909 125 306",
  },
  {
    id: 3,
    name: "18/2 Tăng Bạt Hổ, Phường 11, Quận Bình Thạnh",
    phone: "0988 344 395",
  },
  {
    id: 4,
    name: "113/44/19/3 Huỳnh Tấn Phát, Phường Phú Thuận, Quận 7",
    phone: "0909 980 829",
  },
  {
    id: 5,
    name: "81 Trần Não, Phường Bình An, Quận 2",
    phone: "0909 860 090",
  },
  {
    id: 6,
    name: "321 Hùng Vương, Thị Trấn Đăk Glei, Đăk Glei, Kon Tum",
    phone: "0906 936 383",
  },
  {
    id: 7,
    name: "66/11 Khu Phố 4, Phường Tân Hiệp, Đồng Nai",
    phone: "0937 089 490",
  },
  {
    id: 8,
    name: " 6/25/167 Thanh Nhàn, Phường Quỳnh Lôi, Quận Hai Bà Trưng, Hà Nội",
    phone: " 0979 285 312",
  },
  {
    id: 9,
    name: "SN B2 K97- Phường Tam Phước, Biên Hòa, Đồng Nai",
    phone: "0399 575 217",
  },
];

export function initContent() {
  const categories = [];
  const categoriesById = {};
  for (let category of _categories) {
    let copy = {
      ...category,
      id: database.ref().push().key,
      products: [],
    };
    categoriesById[category.id] = copy;
    categories.push(copy);
  }

  for (let product of _products) {
    let copy = {
      ...product,
      id: database.ref().push().key,
      items: product.items.map((item) => {
        return {
          ...item,
          id: database.ref().push().key,
        };
      }),
    };
    delete copy.category;
    categoriesById[product.category].products.push(copy);
  }

  const introduction = {
    text: _introduction.text.map((text) => {
      return {
        ...text,
        id: database.ref().push().key,
      };
    }),
    signature: _introduction.signature,
  };

  const aboutDetails = _aboutDetails.map((detail) => {
    return {
      ...detail,
      id: database.ref().push().key,
    };
  });

  const nutritionFacts = {
    text: _nutritrionFacts.text.map((text) => {
      return {
        ...text,
        id: database.ref().push().key,
      };
    }),
    background: _nutritrionFacts.background,
  };

  const macaDishes = {
    text: _macaDishes.text.map((text) => {
      return {
        ...text,
        id: database.ref().push().key,
      };
    }),
    dishImages: _macaDishes.dishImages.map((dishImage) => {
      return {
        ...dishImage,
        id: database.ref().push().key,
      };
    }),
  };

  const companyInfo = {
    offices: _companyInfo.offices.map((office) => {
      return {
        ...office,
        id: database.ref().push().key,
      };
    }),
    factories: _companyInfo.factories.map((factory) => {
      return {
        ...factory,
        id: database.ref().push().key,
      };
    }),
  };

  const agencies = _agencies.map((agency) => {
    return {
      ...agency,
      id: database.ref().push().key,
    };
  });

  let updates = {
    [productsTable]: categories,
    [introductionTable]: introduction,
    [aboutDetailsTable]: aboutDetails,
    [nutritionFactsTable]: nutritionFacts,
    [macaDishesTable]: macaDishes,
    [companyInfoTable]: companyInfo,
    [agenciesTable]: agencies,
  };

  contentRef.set(updates).then(
    (resp) => console.log("initialized", resp),
    (error) => console.error(error)
  );
}
window.initContent = initContent;

export function getContent() {
  return new Promise((success, fail) => {
    contentRef.once(
      "value",
      (snapshot) => {
        success(snapshot.val());
      },
      fail
    );
  });
}

export function setContent(content) {
  return database.ref().update({ [contentTable]: content });
}

export function newCategory() {
  return {
    id: database.ref().push().key,
    name: "category name",
    description: "description",
    background: "maca_19.jpg",
    products: [],
  };
}

export function newProduct() {
  return {
    id: database.ref().push().key,
    name: "product name",
    picture: "dau_100.jpg",
    items: [
      {
        id: database.ref().push().key,
        size: "size",
        price: 0,
      },
    ],
  };
}

export function newItem() {
  return {
    id: database.ref().push().key,
    size: "size",
    price: 0,
  };
}

export function newIntroductionText() {
  return {
    id: database.ref().push().key,
    line: "introduction text",
  };
}

export function newAgency() {
  return {
    id: database.ref().push().key,
    name: "Đại lý",
    phone: "0971 864 805",
  };
}

export function newOffice() {
  return {
    id: database.ref().push().key,
    address: "112/38 Tây Hòa, Phước Long A, Q.9, TP.Hồ Chí Minh",
    phone: "0971 864 805 - 0983 841 115",
    email: "macavanphuc@gmail.com",
  };
}
export function newFactory() {
  return {
    id: database.ref().push().key,
    address: "112/38 Tây Hòa, Phước Long A, Q.9, TP.Hồ Chí Minh",
    phone: "0971 864 805 - 0983 841 115",
    email: "macavanphuc@gmail.com",
  };
}
